export default __webpack_public_path__ + "media/shiny-reflection.ed22fc2f.svg";